import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentClaimsPage() {
  return <LatamAgentPage locale="es-MX" agentKey="claims_processing" />;
}
